/**
 * The type of error from the API.
 */
export enum ErrorCodeType {
  InvalidGrant = 'InvalidGrant',
  Unknown = 'Unknown',
  BadRequest = 'BadRequest',
  ServerError = 'ServerError',
  ModelValidation = 'ModelValidation',
  FieldValidation = 'FieldValidation',
  RegexValidation = 'RegexValidation',
  BusinessLogicValidation = 'BusinessLogicValidation',
  SystemUnavailable = 'SystemUnavailable',
  FatalError = 'FatalError',
  DatabaseException = 'DatabaseException',
  ServiceReplyFailureResult = 'ServiceReplyFailureResult',
  WebServiceSecurityError = 'WebServiceSecurityError',
  AccessDeniedError = 'AccessDeniedError',
  UndefinedValidationError = 'UndefinedValidationError',
  DuplicateRequest = 'DuplicateRequest',
  InvalidRequest = 'InvalidRequest',
  InvalidEmail = 'InvalidEmail',
  InvalidPhoneNumber = 'InvalidPhoneNumber',
  InvalidPaymentMethod = 'InvalidPaymentMethod',
  InvalidExpirationDate = 'InvalidExpirationDate',
  InvalidMinimumAmount = 'InvalidMinimumAmount',
  InvalidMaximumAmount = 'InvalidMaximumAmount',
  InvalidMaximumDailyAmount = 'InvalidMaximumDailyAmount',
  MaximumNumberOfTransactionsPerDayReached = 'MaximumNumberOfTransactionsPerDayReached',
  InvalidCurrencyCountryCombination = 'InvalidCurrencyCountryCombination',
  InvalidCountry = 'InvalidCountry',
  InvalidDeliveryMethod = 'InvalidDeliveryMethod',
  InvalidSecurityQuestionAnswer = 'InvalidSecurityQuestionAnswer',
  InvalidDynamicFields = 'InvalidDynamicFields',
  SecurityQuestionAnswerSameAsPassword = 'SecurityQuestionAnswerSameAsPassword',
  InvalidSecurityQuestionCount = 'InvalidSecurityQuestionCount',
  DuplicateSecurityQuestions = 'DuplicateSecurityQuestions',
  DuplicateSecurityQuestionAnswers = 'DuplicateSecurityQuestionAnswers',
  InvalidCredentials = 'InvalidCredentials',
  DuplicateCustomerRegistered = 'DuplicateCustomerRegistered',
  PossibleDuplicateCustomerRegistered = 'PossibleDuplicateCustomerRegistered',
  PossibleDuplicateCustomer = 'PossibleDuplicatedCustomer',
  CustomerAlreadyExists = 'CustomerAlreadyExists',
  CustomerIdRequired = 'CustomerIdRequired',
  CustomerRequiresPersonalInformation = 'CustomerRequiresPersonalInformation',
  CustomerRequiresPersonalInformationUpdate = 'CustomerRequiresPersonalInformationUpdate',
  CustomerRequiresPoBoxAddressUpdate = 'CustomerRequiresPoBoxAddressUpdate',
  CustomerRequiresPasswordUpdate = 'CustomerRequiresPasswordUpdate',
  CustomerLoginAttemptsExceeded = 'CustomerLoginAttemptsExceeded',
  OtpUnavailable = 'OtpUnavailable',
  InvalidSecurityQuestionAnswerAttempts = 'InvalidSecurityQuestionAnswerAttempts',
  CustomerDisabled = 'CustomerDisabled',
  CustomerDisabledWithAdverseAction = 'CustomerDisabledWithAdverseAction',
  CustomerUserCodeHasExpired = 'CustomerUserCodeHasExpired',
  CustomerDisabledAccountLocked = 'CustomerDisabledAccountLocked',
  IncorrectPassword = 'IncorrectPassword',
  MicroDepositVerificationFailedException = "MicroDepositVerificationFailedException",
  PasswordSimilarToEmail = 'PasswordSimilarToEmail',
  PasswordSimilarToOldPassword = 'PasswordSimilarToOldPassword',
  PasswordNotProvided = 'PasswordNotProvider',
  CyberSourceException = 'ExceptionFromCyberSource',
  BluepaySourceException = 'ExceptionFromBluepay',
  MaximumNumberOfPaymentAccountsReached = 'MaximumNumberOfPaymentAccountsReached',
  MaximumNumberOfDisabledPaymentAccountsReached = 'MaximumNumberOfDisabledPaymentAccountsReached',
  PaymentAccountDisabled = 'PaymentAccountDisabled',
  DuplicatePaymentAccount = 'DuplicatePaymentAccount',
  PaymentAccountExpired = 'PaymentAccountExpired',
  BankAccountInformationMissing = 'BankAccountInformationMissing',
  BankAccountFailedVerification = 'BankAccountFailedVerification',
  BankNotFoundException = 'BankNotFoundException',
  BankDetailsRequiredException = 'BankDetailsRequiredException',
  CardTypeNotSupportedException = 'CardTypeNotSupportedException',
  PaymentAccountNotFoundException = 'PaymentAccountNotFoundException',
  PaymentAccountUpdateFailedException = 'PaymentAccountUpdateFailedException',
  InvalidBirthday = 'InvalidBirthday',
  InvalidFutureDate = 'InvalidFutureDate',
  CommunicationException = 'CommunicationException',
  FraudCheckFailureException = 'FraudCheckFailureException',
  FraudBlocked = 'FraudBlocked',
  InvalidDocumentVerificationType = 'InvalidDocumentVerificationType',
  InvalidIdDocumentNumber = 'InvalidIdDocumentNumber',
  InvalidUnitaryAccountNumber = 'InvalidUnitaryAccountNumber',
  CardRequestIdMissing = 'CardRequestIdMissing',
  CardSecurityCodeMissing = 'CardSecurityCodeMissing',
  DeviceFingerPrintSessionIdMissing = 'DeviceFingerPrintSessionIdMissing',
  TelephoneNumberRequired = 'TelephoneNumberRequired',
  TelephoneNumberCellRequiredForNotifications = 'TelephoneNumberCellRequiredForNotifications',
  TelephoneNumberCellRequiredForMarketing = 'TelephoneNumberCellRequiredForMarketing',
  CustomerDeviceVerificationCodeResendsExceeded = 'CustomerDeviceVerificationCodeResendsExceeded',
  CustomerDeviceVerificationAttemptsExceeded = 'CustomerDeviceVerificationAttemptsExceeded',
  CustomerDeviceVerificationHasNotBeenSent = 'CustomerDeviceVerificationHasNotBeenSent',
  CustomerDeviceVerificationCodeDoesNotMatch = 'CustomerDeviceVerificationCodeDoesNotMatch',
  CustomerDeviceVerificationNotSupportedByAgent = 'CustomerDeviceVerificationNotSupportedByAgent',
  CustomerDeviceVerificationNotRequired = 'CustomerDeviceVerificationNotRequired',
  CustomerMatchAttemptsExceeded = 'CustomerMatchAttemptsExceeded',
  CustomerMatchingNotSupportedByAgent = 'CustomerMatchingNotSupportedByAgent',
  NoOfflineCustomerMatched = 'NoOfflineCustomerMatched',
  InvalidProduct = 'InvalidProduct',
  RecipientRequiredForProduct = 'RecipientRequiredForProduct',
  RecipientBankDepositDetailsInvalid = 'RecipientBankDepositDetailsInvalid',
  TrackMoneyTransferInvalidSenderDateOfBirth = 'TrackMoneyTransferInvalidSenderDateOfBirth',
  TrackMoneyTransferInvalidReceivingCountry = 'TrackMoneyTransferInvalidReceivingCountry',
  AddressRequired = 'AddressRequired',
  OrderInvalidSpecificallyExcluded = 'OrderInvalidSpecificallyExcluded',
  ProviderFundsFailed = 'ProviderFundsFailed',
  InvalidPricingModel = 'InvalidPricingModel',
  CountryNotAvailable = 'CountryNotAvailable',
  CountryCurrencyNotAvailable = 'CountryCurrencyNotAvailable',
  StateNotAvailable = 'StateNotAvailable',
  CityNotAvailable = 'CityNotAvailable',
  CurrencyNotAvailable = 'CurrencyNotAvailable',
  PromoCodeAmountOutOfRange = 'PromoCodeAmountOutOfRange',
  ExchangeRateNotAvailable = 'ExchangeRateNotAvailable',
  ExchangeRateChanged = 'ExchangeRateChanged',
  PaymentMethodNotAvailable = 'PaymentMethodNotAvailable',
  TransferNotAvailable = 'TransferNotAvailable',
  DeliveryMethodNotAvailable = 'DeliveryMethodNotAvailable',
  PaymentCardIssuedCountryNotAvailable = 'PaymentCardIssuedCountryNotAvailable',
  PaymentCardDisallowed = 'PaymentCardDisallowed',
  FeeNotAvailable = 'FeeNotAvailable',
  AgentNotFound = 'AgentNotFound',
  AgentSendLimitsNotFound = 'AgentSendLimitsNotFound',
  OrderNotFound = 'OrderNotFound',
  RecipientNotFound = 'RecipientNotFound',
  RecipientCustomerRelationshipNotFound = 'RecipientCustomerRelationshipNotFound',
  PromoCodeNotValid = 'PromoCodeNotValid',
  PromoCodeNotApplicable = 'PromoCodeNotApplicable',
  CustomerNotFound = 'CustomerNotFound',
  LocationNotFound = 'LocationNotFound',
  BankAccountNotFound = 'BankAccountNotFound',
  BankDepositSettingsNotFound = 'BankDepositSettingsNotFound',
  BankDepositProviderNotFound = 'BankDepositProviderNotFound',
  BankDepositProviderCurrencyNotSupported= 'BankDepositProviderCurrencyNotSupported',
  PaymentCardNotFound = 'PaymentCardNotFound',
  IdDocumentTypeIdNotFound = 'IdDocumentTypeIdNotFound',
  BarCodeNotAvailable = 'BarCodeNotAvailable',
  OrderStatusChangeFailed = 'OrderStatusChangeFailed',
  ExternalTransactionNotFound = 'ExternalTransactionNotFound',
  AmountFromNotFound = 'AmountFromNotFound',
  AmountToNotFound = 'AmountToNotFound',
  CannotCalculateTransferFee = 'CannotCalculateTransferFee',
  DuplicateOrder = 'DuplicateOrder',
  OrderNotEligibleForCancellation = 'OrderNotEligibleForCancellation',
  OrderCancellationFailed = 'OrderCancellationFailed',
  RegistrationException = 'RegistrationException',
  CardAuthorizationFailed = 'CardAuthorizationFailed',
  CardSettlementFailed = 'CardSettlementFailed',
  CardNotEnrolledInPayerAuthentication = 'CardNotEnrolledInPayerAuthentication',
  PayerAuthenticationResponseValidationFailed = 'PayerAuthenticationResponseValidationFailed',
  PayerAuthenticationCancelled = 'PayerAuthenticationCancelled',
  StagedTransactionFailed = 'StagedTransactionFailed',
  CyberSourceInvalidSignature = 'CyberSourceInvalidSignature',
  CyberSourceCustomerIdMissing = 'CyberSourceCustomerIdMissing',
  IdentityVerificationRequired = 'IdentityVerificationRequired',
  SarBsaValidation = 'SarBsaValidation',
  IdentityVerificationException = 'IdentityVerificationException',
  IdentityVerificationAttemptsExceeded = 'IdentityVerificationAttemptsExceeded',
  IdentityVerificationSessionExpired = 'IdentityVerificationSessionExpired',
  IdentityVerificationNotAvailable = 'IdentityVerificationNotAvailable',
  IdentityVerificationInvalidSessionId = 'IdentityVerificationInvalidSessionId',
  IdentityVerificationInvalidQuestionId = 'IdentityVerificationInvalidQuestionId',
  IdentityVerificationTaxIdRequired = 'IdentityVerificationTaxIdRequired',
  IdentityVerificationFailed = 'IdentityVerificationFailed',
  DeviceVerificationException = 'DeviceVerificationException',
  InvalidSupportCode = 'InvalidSupportCode',
  IdentityDocumentExpired = 'IdentityDocumentExpired',
  IdentificationDetailsNotFound = 'IdentificationDetailsNotFound',
  IdentificationDetailsRequired = 'IdentificationDetailsRequired',
  IdentificationDocumentRequired = 'IdentificationDocumentRequired',
  DocumentUploadNotSupported = 'DocumentUploadNotSupported',
  EmailFailedToSend = 'EmailFailedToSend',
  EmailMissingAdditionalInfo = 'EmailMissingAdditionalInfo',
  BankAccountUnableToLocate = 'BankAccountUnableToLocate',
  BankAccountUnableToLocateTryAgain = 'BankAccountUnableToLocateTryAgain',
  InvalidToken = 'InvalidToken',
  MissingCountryIsoCodeHeader = 'MissingCountryIsoCodeHeader',
  CountryIsoCodeMismatch = 'CountryIsoCodeMismatch',
  UnsupportedCountry = 'UnsupportedCountry',
  UnsupportedIsoCode = 'UnsupportedIsoCode',
  TrackMoneyTransferUserLockedOutException = 'TrackMoneyTransferUserLockedOutException',
  FindALocationLockedOutException = 'FindALocationLockedOutException',
  PayerAuthenticationRequired = 'PayerAuthenticationRequired',
  CardTokenizationFailed = 'CardTokenizationFailed',
  RequestingCustomerVerification="Errorrequestingcustomerverification",
  CustomerNeedToVerifyIdentityThroughVeriffOnOnfido="CustomerNeedToVerifyIdentityThroughVeriffOnOnfido",
  BankAccountNumber = "BankAccountNumber",
  BankAccountNumberUnitary = "BankAccountNumberUnitary",

  ConnectionError = 'ConnectionError',
  FieldInQuestionPhoneNumber = 'PhoneNumber',
  InvalidAddress = 'InvalidAddress',
  IdentificationDocumentValidationFailed = 'IdentificationDocumentValidationFailed',
  OnlyCountryResidentAllowedOnRegistration = 'OnlyCountryResidentAllowedOnRegistration',
  CardAuthorizationFailed101 = '101',
  CardAuthorizationFailed102 = '102',
  CardAuthorizationFailed103 = '103',
  CardAuthorizationFailed104 = '104',
  CardAuthorizationFailed105 = '105',
  CardAuthorizationFailed106 = '106',
  CardAuthorizationFailed107 = '107',
  CardAuthorizationFailed108 = '108',
  CardAuthorizationFailed109 = '109',
  CardAuthorizationFailed110 = '110',
  CardAuthorizationFailed111 = '111',
  CardAuthorizationFailed112 = '112',
  CardAuthorizationFailed113 = '113',
  AuthorizationRequestApprovedByIssuingBankButAddressVerificationFailed = 'AuthorizationRequestApprovedByIssuingBankButAddressVerificationFailed',
  ExpiredCard = 'ExpiredCard',
  InsufficientFundsInAccount = 'InsufficientFundsInAccount',
  PeselNumberInvalid = 'PeselNumberInvalid', // Only for PL,
  FileType = 'EFTYPE',
  FileSize = 'EFSIZE',
  FileSameFileExists = 'ESFEXST',
  FileNotValid = 'EFNVALID',
  FileGenericError = 'EFGE',
  FileNotSelected = 'No Image Selected', // Need to add it as string because plugin is returning this in exception
  DeepLinkTokenExpired = 'DeepLinkTokenExpired',
  
  VPA_AccountInvalid = 'RecipientBankDepositInvalidAccount',
  VPA_AccountNotActive  = 'RecipientBankDepositInActiveAccount',
  VPA_AccountNotComplete = 'RecipientBankDepositAccountNotComplete',
  VPA_AccountMissing = 'RecipientBankDepositAccountMissing',
  VPA_NetworkError = 'RecipientBankDepositNetworkError',
  VPA_NameMismatch = 'RecipientBankDepositNameMismatch',
  VPA_ValidationFailed = 'RecipientBankDepositValidationFail',
  RecipientBankAccountBlocked = "RecipientBankAccountBlocked",
  KYCVerificationRequired = "KYCVerificationRequired",

  PayerAddressValidation = "PayerAddressValidation", // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! DOUBLE CHECK WITH BE
  ApmAuthorizationFailed = "ApmAuthorizationFailed",
  MBWayAuthorizationFailed117 = '117', // REFUSED
  MBWayAuthorizationFailed118 = '118', // UNKNOWN_PHONE
  ApmCancelledByUser119 = '119',          // MBWAY: CUSTOMER_CANCELLED | TRUELAYER: CANCELLED_BY_USER
  MBWayAuthorizationFailed120 = '120', // OPERATION_REJECTED
  MBWayAuthorizationFailed121 = '121', // LIMIT_EXCEEDED
  MBWayAuthorizationFailed122 = '122', // TIMEOUT
  ApmGenericFailure113 = '113', // GENERAL_ERROR
  
  ApmAuthVerificationFailed114 = '114', // VERIFICATION_FAILED
  ApmInsufficientFunds104 = '104', // BANK_LIMITS
  ApmLimitExceeded106 = '106', // BANK_LIMITS
  BlikBankDeclined116 = '116', // BANK_DECLINED
  BlikUserTimeout115 = '115', // USER_TIMEOUT

  // TrueLayer OpenBanking errors
  TrueLayerBankRejected123 = '123',       // BANK_REJECTED
  TrueLayerAuthFailed124 = '124',         // AUTH_FAILED
  TrueLayerAuthNotAuthorized125 = '125',  // AUTH_NOT_AUTHORIZED
  TrueLayerSessionExpired126 = '126',     // SESSION_EXPIRED
  TrueLayerBankUnavailable127 = '127',    // BANK_UNAVAILABLE
  TrueLayerNameMismatch128 = '128',       // NAME_MISMATCH
  TrueLayerPaymentBlocked129 = '129',     // PAYMENT_BLOCKED

  // Worldpay error codes
  WorldpayNotEnoughMoney = '104',
  WorldpaySuspectedFraud = '105',
  WorldpayWithdrawalLimitExceeded = '106',
  WorldpayInvalidCardNumbers = '107',
  WorldpayCardBlocked = '108',
  WorldpayDoNotHonor = '109',
  WorldpayTransactionNotPermitted = '110',
  WorldpayRestrictedCard = '111',
  WorldpayServiceUnavailable = '112',
  WorldpayGenericDecline = '113',

}

export enum ErrorKeyType {
  StateMissingErrorKey = 'State',
  CityMissingErrorKey = 'City',
  BankRoutingCode = 'BankRoutingCode'
}


export enum SocialLoginErrorCodes {
  // For Token Exchange
  ProvidderNotSupported = 100,
  TokenExchangeFailed = 101,
  IdTokenInvalid = 102,
  IdTokenNotFound = 103,

  UserExistsAndLinked = 200,
  UserExistsButNotLinked=201,
  UserDoesnotExists = 202,

  LinkingSuccesful = 300,
  LinkingFailed = 301,



}


// WEBPACK FOOTER //
// ./src/model/types/error-code-type.ts